import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'tasks',
  version: '0.1.0',
  kind: 'business',
  coreVersion: '^0.1.0',
  name: { vi: 'Công việc & dự án', en: 'Tasks & projects' },
  description: {
    vi: 'Dự án, việc cá nhân, Kanban, giao việc và kiểm tra kết quả, nhắc hạn.',
    en: 'Projects, personal tasks, Kanban, assigning and reviewing work, due reminders.',
  },
  dependsOn: [
    'core-system',
    'core-audit',
    'core-identity',
    'core-organization',
    'core-access',
    'core-files',
    'core-notification',
  ],
  database: { schema: 'tasks' },
  permissions: [
    {
      key: 'tasks.task.use',
      name: { vi: 'Dùng công việc & dự án (tạo dự án, giao việc)', en: 'Use tasks & projects' },
      defaultGranted: true,
    },
    {
      key: 'tasks.project.view',
      name: { vi: 'Xem dự án không tham gia', en: 'View projects one is not a member of' },
      dataScopes: ['department', 'department_tree', 'tenant'],
    },
  ],
  navigation: [
    {
      id: 'tasks',
      label: { vi: 'Công việc', en: 'Tasks' },
      icon: 'check-square',
      order: 45,
      children: [
        {
          id: 'tasks.mine',
          label: { vi: 'Việc của tôi', en: 'My tasks' },
          icon: 'check-square',
          path: '/tasks',
          permission: 'tasks.task.use',
          order: 1,
        },
        {
          id: 'tasks.projects',
          label: { vi: 'Dự án', en: 'Projects' },
          icon: 'folder',
          path: '/tasks/projects',
          permission: 'tasks.task.use',
          order: 2,
        },
      ],
    },
  ],
  notifications: [
    {
      key: 'tasks.assigned',
      name: { vi: 'Được giao việc', en: 'Task assigned to me' },
      defaultChannels: ['in_app', 'email'],
    },
    {
      key: 'tasks.due',
      name: { vi: 'Việc sắp đến hạn / quá hạn', en: 'Task due soon or overdue' },
      description: { vi: 'Trước hạn 1 ngày và khi quá hạn, lúc 8:00.' },
      defaultChannels: ['in_app', 'email'],
    },
    {
      key: 'tasks.comment',
      name: { vi: 'Bình luận, nhắc tên trong công việc', en: 'Task comments and mentions' },
      defaultChannels: ['in_app'],
    },
    {
      key: 'tasks.status',
      name: { vi: 'Việc chờ kiểm tra, xong hoặc bị trả lại', en: 'Task review, done or returned' },
      defaultChannels: ['in_app', 'email'],
    },
  ],
  roleTemplates: [
    {
      key: 'unit-head',
      name: { vi: 'Xem dự án của đơn vị', en: "View the unit's projects" },
      description: { vi: 'Trưởng đơn vị xem dự án của đơn vị mình và các đơn vị con.' },
      grants: [{ permission: 'tasks.project.view', scope: 'department_tree' }],
    },
    {
      key: 'director',
      name: { vi: 'Xem mọi dự án', en: 'View every project' },
      description: { vi: 'Ban giám đốc xem mọi dự án trong công ty.' },
      grants: [{ permission: 'tasks.project.view', scope: 'tenant' }],
    },
  ],
  widgets: [
    {
      key: 'tasks.mine',
      title: { vi: 'Việc của tôi', en: 'My tasks' },
      permission: 'tasks.task.use',
      order: 4,
    },
  ],
});
